export * from './delete-gutachten-status.service';
export * from './delete-gutachten-status.service.module';